import { computed } from 'vue';
import { useChargeTemplateStore } from '../stores/charge-template.store';
// =============================================================================
// COMPOSABLE
// =============================================================================
export function useChargeTemplates() {
    const store = useChargeTemplateStore();
    return {
        templates: computed(() => store.templates),
        editingId: computed(() => store.editingId),
        pendingDeleteId: computed(() => store.pendingDeleteId),
        deleteBlockedBy: computed(() => store.deleteBlockedBy),
        hasTemplates: computed(() => store.hasTemplates),
        isLoading: computed(() => store.isLoading),
        isSaving: computed(() => store.isSaving),
        error: computed(() => store.error),
        templateById: computed(() => store.templateById),
        fetchTemplates: () => store.fetchTemplates(),
        startCreate: () => store.startCreate(),
        startEdit: (id) => store.startEdit(id),
        cancelEdit: () => store.cancelEdit(),
        saveTemplate: (dto) => store.saveTemplate(dto),
        requestDelete: (id) => store.requestDelete(id),
        cancelDelete: () => store.cancelDelete(),
        confirmDelete: () => store.confirmDelete(),
        clearDeleteBlocked: () => store.clearDeleteBlocked(),
    };
}
export default useChargeTemplates;
